import { useMemo } from "react";
import moment from "moment";

import { Auth } from "../routes/Constants";
import LocalStorage from "../shared/localStorage";
import { useLocation } from "react-router-dom";

const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
const parseLocalStorage = JSON.parse(getLocalStorage);

export const useQuery = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};

export function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; /* eslint-disable-line */
  return re.test(email);
}

export function validatePassword(password) {
  return /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%?=*&~]).{8,64})/.test(
    password
  );
}

export function validatePhoneNumber(phoneNumber) {
  /* eslint-disable */
  return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,7}$/im.test(
    phoneNumber
  );
}

export function verifyUserType(type) {
  return type === parseLocalStorage?.user_type;
}

export function verifyUserTypeConnectedRegistrar(type) {
  return type === parseLocalStorage?.connected_nurse?.connected_type;
}

export function formatDateDash(data) {
  const date = new Date(data);

  let day = date.getDate();
  day = day < 10 ? "0" + day : day;

  let month = date.getMonth() + 1;
  month = month < 10 ? "0" + month : month;

  const year = date.getFullYear();

  return year + "-" + month + "-" + day;
}

export function differenceBetweenTwwoDatesInHours(date) {
  let isDay = true;
  let diff = parseInt(Math.abs(new Date(date) - new Date()) / 36e5);
  if (diff < 1) {
    return "Less Than One Hour";
  }

  if (diff > 24) {
    isDay = false;
    diff = Math.ceil(
      Math.abs(new Date(date) - new Date()) / (1000 * 60 * 60 * 24)
    );
  }

  return (
    diff +
    (diff === 1 && isDay
      ? " Hour Ago"
      : diff > 1 && isDay
      ? " Hours Ago"
      : diff === 1 && !isDay
      ? " Day Ago"
      : "  Days Ago")
  );
}

export function isEmptyObject(obj) {
  return (
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
}

export function isObject(obj) {
  return typeof obj === "object" && !Array.isArray(obj) && obj !== null;
}

export function prescriberName() {
  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);

  return (
    parseLocalStorage.first_name.charAt(0)?.toUpperCase() +
    parseLocalStorage.first_name.slice(1) +
    " " +
    parseLocalStorage.last_name.charAt(0)?.toUpperCase() +
    parseLocalStorage.last_name.slice(1)
  );
}

export function prescriberHospitalAddress() {
  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);

  return parseLocalStorage?.hospital?.address?.full_address;
}

export function isPregancyDateOutdate(pregnancy_test) {
  const currentDate = moment().format("l").split("/");
  const formatCurrentDate =
    currentDate[2] + "/" + currentDate[0] + "/" + currentDate[1];

  var date1 = new Date(formatCurrentDate);
  var date2 = new Date(pregnancy_test);

  return Math.abs(moment(date1).diff(moment(date2), "days")) >= 3;
}

export function isDispensingMoreThan7Days(received_date) {
  const currentDate = moment().format("l").split("/");
  const formatCurrentDate =
    currentDate[2] + "/" + currentDate[0] + "/" + currentDate[1];

  var date1 = new Date(formatCurrentDate);
  var date2 = new Date(received_date);

  return Math.abs(moment(date1).diff(moment(date2), "days")) >= 7;
}

export function isDispensingMoreThan7DaysBetween2Dates(data1, data2) {
  var date1 = new Date(data2);
  var date2 = new Date(data1);

  return Math.abs(moment(date1).diff(moment(date2), "days")) <= 7;
}

export function isDispensingMoreThan12WeeksBetween2Dates(data1, data2) {
  var date1 = new Date(data2);
  var date2 = new Date(data1);

  return Math.abs(moment(date1).diff(moment(date2), "weeks")) <= 12;
}

export function isDispensingMoreThan3DaysBetween2Dates(data1, data2) {
  var date1 = new Date(data2);
  var date2 = new Date(data1);

  return Math.abs(moment(date1).diff(moment(date2), "days")) > 3;
}

export function calculateRenewalDays(received_date) {
  // For testing: adding at current date n days
  // const currentDate = moment().add(7, "days").valueOf();
  const currentDate = moment().valueOf();
  const receivedDataTimestamp = moment(received_date).valueOf();
  const finalCompletionTimestamp = moment(receivedDataTimestamp)
    .add(7, "days")
    .endOf("day")
    .valueOf();

  if (
    finalCompletionTimestamp < currentDate ||
    moment(finalCompletionTimestamp).isSame(currentDate, "days")
  ) {
    return "PAF Overdue";
  }

  return `Renewal within ${moment(finalCompletionTimestamp).diff(
    currentDate,
    "days"
  )} days`;
}

export function getTotalCapsules(form) {
  let capsulesValue = form?.capsules_per_cycle?.value;
  if (capsulesValue === 0) {
    capsulesValue = form?.capsules_per_cycle_other;
  }

  let cyclesValue = form?.number_cycles?.value;
  if (cyclesValue === 0) {
    cyclesValue = form?.number_cycles_other;
  }

  return capsulesValue * cyclesValue;
}

export const displayPhoneNumberWithSpace = (number) => {
  const phone = [number?.slice(0, 2), " ", number?.slice(2)].join("");
  return phone;
};

export const formatPhoneNumber = (phoneNumber) => {
  let newPhoneNumber = phoneNumber;
  if (newPhoneNumber.length === 1) {
    return (newPhoneNumber = newPhoneNumber.replace(/ /g, ""));
  } else {
    return newPhoneNumber;
  }
};

export const handleCatch = (error) => {
  if (error.response.status === 404) {
    window.location.href = "/404";
    return;
  }
  if (error?.response?.status === 401 && error?.response?.data?.tokenExpired) {
    const message = error?.response?.data?.tokenExpired;
    localStorage.setItem(LocalStorage.EXPIRED_SESSION_MESSAGE_IRELAND, message);
    window.location.href = Auth.LOGIN;
  }

  if (error?.response?.status === 403) {
    const message = error?.response?.data?.detail;
    localStorage.setItem(LocalStorage.EXPIRED_SESSION_MESSAGE_IRELAND, message);
    localStorage.removeItem(LocalStorage.USER_IRELAND);
    window.location.href = Auth.LOGIN;
  }

  if (
    error?.response?.data?.detail === "Invalid token." ||
    error?.response?.status === 401
  ) {
    localStorage.removeItem(LocalStorage.USER_IRELAND);
    window.location.href = Auth.LOGIN;
  }
};

export const getUserGuidePdf = () => {
  return process.env.REACT_APP_NODE_ENV === "production"
    ? "https://psh-ie-files-live.s3.eu-west-1.amazonaws.com/lenalidomide_user_guide.pdf"
    : process.env.REACT_APP_NODE_ENV === "development"
    ? "https://psh-ie-files-dev.s3.eu-west-1.amazonaws.com/lenalidomide_user_guide.pdf"
    : "https://psh-ie-files-stg.s3.eu-west-1.amazonaws.com/lenalidomide_user_guide.pdf";
};

export const getPrescriberTrainingVideo = () => {
  return process.env.REACT_APP_NODE_ENV === "production"
    ? "https://psh-ie-files-live.s3.eu-west-1.amazonaws.com/prescribing_physician.mp4"
    : process.env.REACT_APP_NODE_ENV === "development"
    ? "https://psh-ie-files-dev.s3.eu-west-1.amazonaws.com/prescribing_physician.mp4"
    : "https://psh-ie-files-stg.s3.eu-west-1.amazonaws.com/prescribing_physician.mp4";
};

export const getPharmacyTrainingVideo = () => {
  return process.env.REACT_APP_NODE_ENV === "production"
    ? "https://psh-ie-files-live.s3.eu-west-1.amazonaws.com/pharmacy_training.mp4"
    : process.env.REACT_APP_NODE_ENV === "development"
    ? "https://psh-ie-files-dev.s3.eu-west-1.amazonaws.com/pharmacy_training.mp4"
    : "https://psh-ie-files-stg.s3.eu-west-1.amazonaws.com/pharmacy_training.mp4";
};
